module.exports = __webpack_public_path__ + "static/media/administration.af0d9d0e.svg";